/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询订单下单状态
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  uuid: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.MoviePayInfoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/movie/orderStatus/${uuid}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
